import { ReactNode, useContext, useEffect, useState } from "react";
import { ChatbotStateContext } from "../utils/chatbotContext";

export const ChatbotLayoutContainer = ({ sideContent, mainContent, isNavVisible }: { sideContent: ReactNode, mainContent: ReactNode, isNavVisible: boolean }) => {
  const chatbotCurrentState = useContext(ChatbotStateContext);
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    if (chatbotCurrentState.currentState !== "Connected State") {
      setShowOverlay(true);
    } else {
      setShowOverlay(false);
    }
  }, [chatbotCurrentState.currentState]);


  return (
    <div className="relative">
      {showOverlay && (
        <div className="absolute inset-0 bg-white z-10"></div>
      )}
      <div className="flex mt-2 h-[calc(100vh-11rem)] outline outline-2 outline-ua-pink  overflow-hidden]">
        <div className={`h-[calc(100vh-11rem)] overflow-auto transition-all duration-300 ${isNavVisible ? "w-1/5 outline outline-2 outline-ua-pink" : "w-0"}`}>
          {sideContent}
        </div>
        <div className={`flex flex-col h-[calc(100vh-11rem)] overflow-auto transition-all duration-300 ${isNavVisible ? "w-4/5" : "w-full"} `}>
          {mainContent}
        </div>
      </div>
    </div>
  );
};